// extracted by mini-css-extract-plugin
export default {"main":"Main_main__DUWic","inputs":"Main_inputs__0KeTz"};